import React from 'react';

const Unauthorized = (props) => {
    return (
        <>
            {props.children}
        </>
    );
};

export default Unauthorized;